import React from "react";
import { navigate } from "@reach/router";

const MobileMenuItem = ({ setDisplay, icon, href, name, handle }) => {
  return (
    <li
      className="nav-item mobile"
      onClick={() => {
        setDisplay(false);
        if (handle) navigate(handle);
        else if (href) window.open(href, "_blank");
      }}
    >
      <div className="row align-items-center">
        <div className="col-10">
          {icon && icon !== null && <i className={`me-2 ${icon}`} />}
          {name}
        </div>
        <div className="col-2 text-end">
          <i className="fa fa-chevron-right"></i>
        </div>
      </div>
    </li>
  );
};

export default MobileMenuItem;
